import moment from 'moment'

moment.locale('ru')

export default (ctx, inject) => {
  ctx.$moment = moment
  inject('moment', moment)
}
